import {TopBrandPromo} from "./top_brandpromo";
import {Logger} from "./logger";
import {otto} from "@otto-ec/global-resources/nexus";

otto.ft3.promo.brandpromo.assignNamespace({
    init,
});

function init(): void {
    Logger.group("[FT3 promo brandpromo]");
    Logger.count("TopBrandPromo Invocation");
    const containers = document.querySelectorAll('.promo-brandpromo__top-brandpromo');

    containers.forEach((container: Element) => {
        if (container.getAttribute("data-tracked") !== "true") {
            container.setAttribute("data-tracked", "true");
            new TopBrandPromo(container);
        }
    });

    Logger.groupEnd();
}
